import React from "react";
import CompanyCards from "./base/CompanyCards";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import Reveal from "./base/Reveal";
import { accent } from "../constants/constants";

const Experience: React.FC = () => {
  return (
    <Box
      as="section"
      id="experience"
      aria-labelledby="experience-heading"
      bg="brand.bg"
      scrollMarginTop={{ base: "70px", md: "90px" }}
    >
      <Flex
        minHeight="100vh"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        padding={{ base: "2rem", md: "4rem" }}
        flexWrap="wrap"
      >
        <Box maxWidth="800px" textAlign="center" mb={{ base: 12, md: 16 }}>
          <Reveal>
            <Heading
              id="experience-heading"
              fontSize={{ base: "4xl", md: "6xl" }}
              fontWeight={900}
              color="brand.text"
            >
              I build reliable software for{" "}
              <Box as="span" color={accent}>
                companies making an impact.
              </Box>
            </Heading>
          </Reveal>
          <Reveal delay={0.15}>
            <Text
              fontSize={{ base: "md", md: "lg" }}
              color="brand.muted"
              mt={6}
            >
              From disability support platforms to building automation,
              I&apos;ve shipped backend and full-stack systems that real people
              rely on every day. Tap a company to see what I worked on.
            </Text>
          </Reveal>
        </Box>
        <Reveal delay={0.25} width="100%">
          <CompanyCards />
        </Reveal>
      </Flex>
    </Box>
  );
};

export default Experience;
